<template>
  <div class="page-container md-layout-column">
    <span class="md-caption">Информация о заказе</span>
    <md-table>
      <md-table-row>
        <md-table-cell>Номер заказа в ТД</md-table-cell>
        <md-table-cell>{{order.order.Id}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Частичка</md-table-cell>
        <md-table-cell v-if="forChoiceName==='Разрешена'" style="color: green">{{forChoiceName}}</md-table-cell>
        <md-table-cell v-else style="color: red">{{forChoiceName}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Вскрытие</md-table-cell>
        <md-table-cell v-if="notOpenName==='Разрешено'" style="color: green">{{notOpenName}}</md-table-cell>
        <md-table-cell v-else style="color: red">{{notOpenName}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Взять деньни за доставку</md-table-cell>
        <md-table-cell v-if="!deliveryCostPayAnyway" style="color: green">Не требуется</md-table-cell>
        <md-table-cell v-else style="color: red">Требуется</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Номер заказа ИМ</md-table-cell>
        <md-table-cell>{{order.order.WebshopNumber}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Бар-код</md-table-cell>
        <md-table-cell>{{order.order.BarCode}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>ФИО получателя</md-table-cell>
        <md-table-cell>{{order.order.ClientFio}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Адрес получателя</md-table-cell>
        <md-table-cell>{{order.order.DeliveryStreet}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Контактный телефон</md-table-cell>
        <md-table-cell>
          <a href="tel:order.order.ClientPhone">{{order.order.ClientPhone}}</a>
        </md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Регион доставки</md-table-cell>
        <md-table-cell>{{order.region.title}}</md-table-cell>
      </md-table-row>

      <md-table-row>
        <md-table-cell>Город доставки</md-table-cell>
        <md-table-cell>{{order.city.Title}}</md-table-cell>
      </md-table-row>

    </md-table>

    <md-content v-if="order.order.WorkStatusId === 1 || order.order.WorkStatusId === 2">
      <md-button class="md-raised md-accent" v-on:click="selectedStatus">Проставить статус</md-button>
    </md-content>
    <md-content v-else>
      <md-button class="md-raised md-accent" disabled> Заказ уже имеет финальный статус {{nameWorkStatus}}</md-button>
    </md-content>
  </div>
</template>

<script>
  export default {
    props: ['order'],
    methods: {
      selectedStatus: function () {
        this.$router.push({path: `/select_final_status/${this.$props.order.order.Id}`});
        this.$parent.selectStatus = true
      }
    },
    computed: {
      deliveryCostPayAnyway() {
        if (this.$props.order.order.deliveryCostPayAnyway) return true;

        // todo костыль для купи випа
        let kupiIds = [1708, 1921, 1787, 1839, 1820, 1761, 1924];
        return kupiIds.includes(Number(this.$props.order.order.WebshopId));
      },
      nameWorkStatus() {
        if (this.$props.order.order.WorkStatusId === 3) return '"Полностью выполнен"';
        if (this.$props.order.order.WorkStatusId === 4) return '"Частично выполнен"';
        if (this.$props.order.order.WorkStatusId === 5) return '"Отказ"';
      },
      notOpenName() {
        if (this.$props.order.order.NotOpen === 0) {
          return `Разрешено`
        } else {
          return 'Не разрешено'
        }
      },
      forChoiceName() {
        if (this.$props.order.order.ForChoice === 1) {
          return 'Разрешена'
        } else {
          return 'Не разрешена'
        }
      },
    }
  }
</script>

<style scoped>
  table {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order.vue